{
  "title": "Dashboard",
  "description": "Overview of your business or institution performance and analytics",
  "descriptionSelect": "Select a business or institution to view analytics",
  "descriptionGetStarted": "Get started by creating your first business or institution",
  "greetingMorning": "Good morning",
  "greetingAfternoon": "Good afternoon",
  "greetingEvening": "Good evening",
  "welcomeSubtitle": "Here's what's happening with your business or institution today.",
  "emptyNoBusinessTitle": "No Business or Institution Yet",
  "emptyNoBusinessDescription": "Create your first business or institution to get started with managing your services, appointments, and more.",
  "emptyNoBusinessCta": "Create Your First Business or Institution",
  "emptyNoBusinessHint": "You can create multiple businesses or institutions and switch between them anytime.",
  "emptyNotSelectedTitle": "No Business or Institution Selected",
  "emptyNotSelectedDescription": "Please select a business or institution from the sidebar to view its analytics and performance.",
  "loadError": "Failed to load dashboard data.",
  "tryAgain": "Try again",
  "chartBookings": "Bookings chart unavailable",
  "chartFulfillment": "Fulfillment chart unavailable",
  "chartRevenue": "Revenue chart unavailable",
  "chartCustomerGrowth": "Customer growth chart unavailable",
  "chartAppointmentStatus": "Appointment status chart unavailable",
  "chartServicePerformance": "Service performance chart unavailable",
  "chartPeakHours": "Peak hours chart unavailable",
  "chartRatings": "Ratings chart unavailable",
  "chartAppointmentsTable": "Appointments table unavailable",
  "starSingular": "Star",
  "starPlural": "Stars",
  "charts": {
    "timeRange": {
      "placeholder": "Select range",
      "daily": "Daily",
      "monthly": "Monthly",
      "yearly": "Yearly"
    },
    "trend": {
      "up": "Trending up by {{percent}}% this month",
      "down": "Trending down by {{percent}}% this month"
    },
    "ranges": {
      "last10Days": "Last 10 days",
      "last6Months": "Last 6 months"
    },
    "bookings": {
      "title": "Total Bookings",
      "description": "Completed bookings over the last 10 days",
      "metricLabel": "Bookings"
    },
    "revenue": {
      "title": "Revenue",
      "description": "Total revenue generated over the last 6 months",
      "metricLabel": "Revenue",
      "totalPrefix": "Total: GH₵{{total}}",
      "rangeWithTotal": "{{range}} • Total: GH₵{{total}}"
    },
    "fulfillment": {
      "title": "Services Fulfillment Rate",
      "description": "Percentage of completed services",
      "fulfilledLabel": "Fulfilled",
      "target": "Target",
      "current": "Current"
    },
    "customerGrowth": {
      "title": "Customer Growth",
      "description": "New and returning customers over the last 6 months",
      "labels": {
        "new": "New Customers",
        "returning": "Returning Customers"
      },
      "summary": "{{range}} • New: {{new}} • Returning: {{returning}}"
    },
    "customerSatisfaction": {
      "title": "Customer Satisfaction",
      "description": "Rating distribution from customer reviews",
      "metricLabel": "Reviews",
      "averageRating": "Average rating: {{rating}}/5",
      "fromReviews": "from {{count}} reviews",
      "averageRatingFromReviews": "Average rating: {{rating}}/5 from {{count}} reviews",
      "ratingLabel": "{{count}} {{starLabel}}"
    },
    "appointmentStatus": {
      "title": "Appointment Status",
      "description": "Distribution of appointments by status",
      "total": "Total appointments: {{total}}",
      "statuses": {
        "COMPLETED": "Completed",
        "PENDING": "Pending",
        "CANCELLED": "Cancelled",
        "RESCHEDULED": "Rescheduled",
        "ACTIVE": "Active"
      }
    },
    "peakHours": {
      "title": "Peak Hours",
      "description": "Booking distribution throughout the day",
      "metricLabel": "Bookings",
      "peakBookingTime": "Peak booking time:"
    },
    "servicePerformance": {
      "title": "Service Performance",
      "description": "Bookings and revenue by service type",
      "labels": {
        "bookings": "Bookings",
        "revenue": "Revenue"
      },
      "topService": "Top service: {{service}}",
      "noServices": "No services"
    },
    "appointmentsTable": {
      "title": "Upcoming Appointments",
      "description": "Next scheduled appointments from today onward (UTC)",
      "fallbacks": {
        "customer": "Customer",
        "service": "Service",
        "time": "--"
      },
      "columns": {
        "customer": "Customer",
        "name": "Name",
        "service": "Service",
        "dateTime": "Date & Time"
      },
      "empty": {
        "title": "No upcoming appointments",
        "descriptionWithBusiness": "No scheduled appointments from today for this business ({{businessId}}). If you expect one, confirm it belongs to this business in the Appointments page.",
        "descriptionWithoutBusiness": "No scheduled appointments from today for the selected business."
      }
    }
  },
  "quickActions": {
    "title": "Quick Actions",
    "addProvider": "Add Provider",
    "newService": "New Service",
    "appointments": "Appointments",
    "income": "Income"
  },
  "kpi": {
    "totalBookings": "Total Bookings",
    "totalBookingsDescription": "All time bookings",
    "totalRevenue": "Total Revenue",
    "totalRevenueDescription": "Total earnings",
    "totalCustomers": "Total Customers",
    "totalCustomersDescription": "Active customers",
    "averageRating": "Average Rating",
    "averageRatingDescription": "Customer satisfaction",
    "notAvailable": "N/A",
    "changeFromLastPeriod": "{{percent}}% from last period"
  },
  "onboarding": {
    "title": "Get your business ready",
    "progress": "{{completed}} of {{total}} steps complete",
    "dismiss": "Dismiss checklist",
    "pendingApproval": "Your business is pending approval. Most setup steps unlock once an admin verifies your profile.",
    "continue": "Continue: {{step}}",
    "steps": {
      "approved": {
        "title": "Business approved",
        "descriptionApproved": "Your business is verified and ready for setup.",
        "descriptionPending": "Your business is under review. You can prepare providers and services once approved.",
        "descriptionRejected": "Your business was not approved. Contact support or update your profile."
      },
      "providers": {
        "title": "Add a service provider",
        "description": "Providers deliver your services and are assigned to units."
      },
      "services": {
        "title": "Create a service",
        "description": "Define what customers can book — name, pricing, and image."
      },
      "units": {
        "title": "Configure units & availability",
        "description": "Add service units with providers and weekly time slots."
      },
      "activate": {
        "title": "Activate for customers",
        "description": "Make your service visible in the customer app."
      }
    }
  }
}
